import React from 'react';
import { motion } from 'framer-motion';
import { GitMergeIcon, Share2Icon, BellRingIcon, LayoutDashboardIcon, RefreshCwIcon, TargetIcon } from 'lucide-react';
const features = [{
  icon: GitMergeIcon,
  title: 'Signal unification',
  body: 'Identity resolution and field mapping merge every source into one clean, queryable model.'
}, {
  icon: Share2Icon,
  title: 'Multi-touch attribution',
  body: 'See the full path from first ad click to closed-won across paid, organic and sales touches.'
}, {
  icon: BellRingIcon,
  title: 'Real-time alerts',
  body: 'Trigger Slack, email or webhook the moment a high-intent account or spend anomaly appears.'
}, {
  icon: LayoutDashboardIcon,
  title: 'Custom dashboards',
  body: 'Compose board-ready views mixing spend, pipeline and product metrics — no SQL required.'
}, {
  icon: RefreshCwIcon,
  title: 'Audience & segment sync',
  body: 'Push unified segments back into Meta, Google and HubSpot to activate what you learn.'
}, {
  icon: TargetIcon,
  title: 'Lead & account scoring',
  body: 'Blend intent, fit and engagement signals into a single score your reps actually trust.'
}];
export function Features() {
  return <section id="features" className="bg-white py-20 md:py-28" data-id="element-38">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-39">
        <h2 className="max-w-2xl font-display text-4xl font-semibold leading-[1.05] tracking-tight md:text-6xl" data-id="element-40">
          One platform for the entire signal lifecycle.
        </h2>

        <div className="mt-14 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-41">
          {features.map((f, i) => <motion.div key={f.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} className="border-t-2 border-ink pt-5" data-id="element-42">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-cream text-signal ring-1 ring-ink/10" data-id="element-43">
                <f.icon className="h-5 w-5" data-id="element-44" />
              </div>
              <h3 className="mt-5 text-xl font-semibold" data-id="element-45">{f.title}</h3>
              <p className="mt-2 text-ink/60" data-id="element-46">{f.body}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}